
<script>
export default {
    data() {
        return { 
            copyCount:2,
            content:'' 
        };
    },
    computed:{
        today() {
            const today = new Date();
            const day = today.getDate();
            const month = today.getMonth() + 1; // getMonth() 0 ile başlar, bu yüzden 1 eklemelisiniz
            const year = today.getFullYear();
            const formattedDate = `${day}-${month}-${year}`;
           
           return formattedDate;
        },
        makbuzTotalAmount() {
            return this.content.receipt_data?.reduce((sum, detail) => sum + parseFloat(detail.amount), 0);
        },
        invoiceTotalAmount() {
            return this.content.invoice_data?.reduce((sum, detail) => sum + parseFloat(detail.amount), 0);
        },
        invoiceTotalBrut() {
            return parseFloat(this.invoiceTotalAmount) - parseFloat(this.invoiceTotalKDV);
        },
        invoiceTotalKDV() {
            const kdvRate = 0.16;
            return this.invoiceTotalAmount * (kdvRate / (1 + kdvRate));
        }
    },
    filters:{
        virgul(data){
            if (isNaN(data)) {
                return '';
            }
            return parseFloat(data).toFixed(2).replace('.', ',') + ' TL'
        }
    },
    methods: {
        numberToWords(sayi) {
            if(!sayi) return 

          
            var sayarr = parseFloat(sayi).toFixed(2).replace('.', ',').toString().split(',');
            var str = "";
            var items = [
                ["", ""],
                ["BİR", "ON"],
                ["İKİ", "YİRMİ"],
                ["ÜÇ", "OTUZ"],
                ["DÖRT", "KIRK"],
                ["BEŞ", "ELLİ"],
                ["ALTI", "ALTMIŞ"],
                ["YEDİ", "YETMİŞ"],
                ["SEKİZ", "SEKSEN"],
                ["DOKUZ", "DOKSAN"]
            ];
            var eleman = 0
            var basamak = 0
            var basamakd = 0

            for (eleman = 0; eleman < sayarr.length; eleman++) {
                for (basamak = 1; basamak <= sayarr[eleman].length; basamak++) {
                    basamakd = 1 + (sayarr[eleman].length - basamak);
                    try {
                        switch (basamakd) {
                        case 6:
                            str = str + "" + items[sayarr[eleman].charAt(basamak - 1)][0] + "YÜZ";
                            break;
                        case 5:
                            str = str + "" + items[sayarr[eleman].charAt(basamak - 1)][1];
                            break;
                        case 4:
                            if (items[sayarr[eleman].charAt(basamak - 1)][0] != "BİR") str = str + "" + items[sayarr[eleman].charAt(basamak - 1)][0] + "BİN";
                            else str = str + "BİN";
                            break;
                        case 3:
                            if (items[sayarr[eleman].charAt(basamak - 1)][0] == "") {
                                str = str + "";

                            }
                            else if(items[sayarr[eleman].charAt(basamak - 1)][0] != "BİR") str = str + "" + items[sayarr[eleman].charAt(basamak - 1)][0] + "YÜZ";
                            else str = str + "YÜZ";
                            break;
                        case 2:
                            str = str + "" + items[sayarr[eleman].charAt(basamak - 1)][1];
                            break;
                        default:
                            str = str + "" + items[sayarr[eleman].charAt(basamak - 1)][0];
                            break;
                        }
                    } catch (err) {
                        alert(err.description);
                        alert("eleman" + basamak);
                        break;
                    }
                }
               if (eleman < 1) {
                    str = str + "TL";
                } else {
                    if (sayarr[1] != "00") {
                        str = str + "KRS";
                    }
                }
            }
            return '#' + str + '#';
        },
        print(invoice) {
          
            this.content = invoice;
            this.$nextTick(() => {

                const fontLinks = `
                    <link rel="preconnect" href="https://fonts.googleapis.com">
                    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
                    <link href="https://fonts.googleapis.com/css2?family=Roboto+Mono:ital,wght@0,100..700;1,100..700&family=Rubik:ital,wght@0,300..900;1,300..900&display=swap" rel="stylesheet">
                `;
                const fontStyle = `
                    <style>
                        *{ 
                            font-size:14.5px!important;
                            font-weight:400;
                            margin:0px;
                            padding:0px;
                            font-family: 'Roboto Mono', 'Rubik', sans-serif;
                        }
                    </style>
                    `;

                const printContent = this.content.type == 'makbuz' ? this.$refs.makbuzContent.innerHTML : this.$refs.printContent.innerHTML;

                const printWindow = window.open('', '', 'width=600,height=600');
                printWindow.document.open();
                printWindow.document.write(`
                    <html>
                        <head>
                            <title>Yazdır</title>
                            ${fontLinks}
                            ${fontStyle}
                        </head>
                        <body>
                            ${printContent}
                        </body>
                    </html>
                `);
                printWindow.document.write(printContent);
                printWindow.document.write('</body></html>');
                printWindow.document.close();
                printWindow.print();
            });
        },
    },
};
</script>

<template>
<div>
    <div id="makbuzContent" style="display:none" ref="makbuzContent">
        <div class="row">
            <div style="width:100%;margin-top:5cm">
                <table style="width:100%; ">
                    <tbody>
                        <tr>
                            <th style="height:.8cm;text-align:left;width:25%;">TARİH</th>
                            <td style="height:.8cm;text-align:left;">{{ content.subs.transaction_date || today }}</td>
                        </tr>
                        <tr> 
                            <th style="height:.8cm;text-align:left;width:25%;">ÖDEME</th>
                            <td style="height:.8cm;text-align:left;">{{ content.pay_detail.payment_type_title }}</td>
                        </tr>
                        <tr>
                            <th style="height:.8cm;text-align:left;width:25%;">AÇIKLAMA</th>
                            <td style="height:.8cm;text-align:left">{{ content.receipt_desc }}</td>
                        </tr>
                        <tr>
                            <th style="height:.8cm;text-align:left;width:25%;">TUTAR</th>
                            <td style="height:.8cm;text-align:left;">{{ makbuzTotalAmount | virgul }} <br>#{{ numberToWords(makbuzTotalAmount) }}#</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="margin-top:50px;">
                <div style="width:45%;display:inline-block;">
                    <strong style="padding-bottom:20px">Ödemeyi Yapan</strong>
                    <div style='width:95%;border-bottom:dashed 1px'></div>
                    {{ content.subs.username }} - {{ content.subs.fname }} {{ content.subs.lname }}
                </div>
                 <div style="width:45%;display:inline-block;">
                    <strong style="padding-bottom:20px">Ödemeyi Alan</strong>
                    <div style='width:95%;border-bottom:dashed 1px'></div>
                   {{ content.pay_detail.user_name }}
                </div>
            </div>
        </div>
    </div>
    <div id="printContent" style="display:none" ref="printContent">
        <div class="row" style="margin-bottom:50px">
            <div>
                <div style="margin-top:3.5cm;width:50%;display:inline-block">
                    <p style="height:35px">{{ content.invoice_name }}</p>
                    <p>{{ content.subs.address }}</p>
                </div>
                <div style="margin-top:3.5cm;width:49%;display:inline-block">
                    <p style="float:right">{{ today }}</p>
                </div>
            </div>
            <div style="width:100%;margin-top:15px">
                <table style="width:100%; ">
                    <thead>
                        <tr>
                            <th style="height:.8cm;text-align:left;">#</th>
                            <th style="height:.8cm;text-align:left;width:50%;border-bottom:dashed 1px #d5d5d5;">AÇIKLAMA</th>
                            <th style="height:.8cm;text-align:right;width:10%;border-bottom:dashed 1px #d5d5d5;">MİKTAR</th>
                            <th style="height:.8cm;text-align:right;width:15%;border-bottom:dashed 1px #d5d5d5;">FİYAT</th>
                            <th style="height:.8cm;text-align:right;width:20%;border-bottom:dashed 1px #d5d5d5;">TUTAR</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style="height:.8cm;text-align:left;border-bottom:dashed 1px #d5d5d5;">1</td>
                            <td style="height:.8cm;text-align:left;border-bottom:dashed 1px #d5d5d5;">{{ content.invoice_desc }}</td>
                            <td style="height:.8cm;text-align:right;border-bottom:dashed 1px #d5d5d5;">{{ content.invoice_qty }} Ay</td>
                            <td style="height:.8cm;text-align:right;border-bottom:dashed 1px #d5d5d5;">{{ invoiceTotalBrut | virgul }}</td>
                            <td style="height:.8cm;text-align:right;border-bottom:dashed 1px #d5d5d5;">{{ invoiceTotalBrut | virgul }}</td>
                        </tr>
                        <template>
                            <tr v-for="line in 4" :key="line">
                                <td colspan="4" style="height:.8cm"></td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div>
                <div style="width:60%;display:inline-block">
                    <p>{{ numberToWords(invoiceTotalAmount) }}</p>
                    <p>{{ content.subs.username }} - {{ content.subs.fname }} {{ content.subs.lname }}</p>
                </div>
                <div style="width:40%;display:inline-block;float:right">
                    <table style="width:100%">
                        <tbody>
                            <tr>
                                <th style="text-align:right;width:60%;">BRÜT</th>
                                <td style="text-align:right;width:60%;">{{ invoiceTotalBrut | virgul }}</td>
                            </tr>
                            <tr>
                                <th style="text-align:right;width:60%;">KDV</th>
                                <td style="text-align:right;width:60%;">{{ invoiceTotalKDV | virgul  }}</td>
                            </tr>
                            <tr>
                                <th style="text-align:right;width:60%;">TOPLAM</th>
                                <td style="text-align:right;width:60%;">{{ invoiceTotalAmount | virgul   }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div>
                <div style="margin-top:20px;margin-left:120px;width:100%">
                    <table>
                        <tbody>
                            <tr>
                                <td colspan="2">PRİMENET İNTERNET SERVİS SAĞLAYICILIĞI LTD.</td>
                            </tr>
                            <tr>
                                <td>TR87 0013 4000 0235 2346 9000 01</td>
                            </tr>
                            <tr>
                                <td>USD TR33 0013 4000 0235 2346 9000 03</td>
                            </tr>
                        </tbody>
                    </table>
                    <p style="margin-top:20px;display:inline-block">Teslim Eden ...............</p>
                    <p style="margin-top:20px;margin-left:50px;display:inline-block">Teslim Alan ...............</p>
                </div>
            </div>
        
    </div>
    </div>
</div>
</template>